module.exports = __webpack_public_path__ + "images/friesland_small0bfaec4608dca2f42d10fbb3b801ca8a.png";